import axios from 'axios';
import { API_BASE_URL } from './config';

const adminApi = axios.create({
  baseURL: API_BASE_URL,
  timeout: 60000,
});

// 请求拦截器：添加认证信息
adminApi.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('admin_token');
    if (token) {
      config.headers = config.headers || {};
      config.headers.Authorization = `Bearer ${token}`;
    }

    const adminUser = localStorage.getItem('admin_user');
    if (adminUser) {
      try {
        const userData = JSON.parse(adminUser);
        if (userData.id) {
          config.headers = config.headers || {};
          config.headers['X-User-ID'] = userData.id.toString();
        }
      } catch (e) {
      }
    }

    // 关键：如果是 FormData，不要让 axios/浏览器误用 json 头。
    // 让浏览器自动设置 multipart/form-data; boundary=...
    if (config.data instanceof FormData) {
      config.headers = config.headers || {};
      if (config.headers['Content-Type']) delete config.headers['Content-Type'];
      if (config.headers['content-type']) delete config.headers['content-type'];
    }

    return config;
  },
  (error) => Promise.reject(error)
);

// 响应拦截器：处理认证错误和token黑名单
adminApi.interceptors.response.use(
  (response) => response,
  async (error) => {
    const status = error.response?.status;
    const detail = error.response?.data?.detail;

    // 401: 未授权 - token无效、过期、被吊销或黑名单
    if (status === 401) {
      // 清理本地存储
      localStorage.removeItem('admin_token');
      localStorage.removeItem('admin_user');

      // 只在非登录页面时跳转，避免循环重定向
      if (!window.location.pathname.startsWith('/sys-portal/login')) {
        window.location.href = '/sys-portal/login';
      }
    }

    // 403: 权限不足
    if (status === 403) {
      if (typeof detail === 'string' && detail.includes('权限不足')) {
        alert('您没有权限执行此操作');
      }
    }

    return Promise.reject(error);
  }
);

export default adminApi;
